if (!customElements.get('mobile-menu-drawer')) {
  class MobileMenuDrawer extends HTMLElement {
    constructor() {
      super();
      // Store the bound event handler for consistent removal
      this.boundBodyClick = this.onBodyClick.bind(this);
    }

    connectedCallback() {
      this.body = document.body;
      this.selectors = {
        headerBurgerMenu: document.querySelectorAll('.header-burger-menu'),
        drawerClose: this.querySelector('.drawer-header button'),
        toggleButton: this.querySelectorAll('.mobile-nav-toggle button')
      };

      this.selectors.headerBurgerMenu.forEach(btn => {
        btn.addEventListener('click', () => {
          this.classList.add("is-open");
          document.body.classList.add("menu-drawer-open");
          // Only add if not already added
          if (!this.hasBodyClickListener) {
            this.body.addEventListener('click', this.boundBodyClick);
            this.hasBodyClickListener = true;
          }
        });
      });

      this.selectors.drawerClose.addEventListener('click', () => {
        this.closeDrawer();
      });

      this.selectors.toggleButton.forEach(btn => {
        btn.addEventListener('click', event => {
          const mobileSubList = event?.target?.closest('.mobile-nav-item')?.querySelector('.mobile-nav-sublist');
          const buttonToggle = event?.target?.closest('.collapsible-trigger');
          buttonToggle && buttonToggle.classList.toggle('is-open');
          if (mobileSubList) {
            this.toggleSubList(mobileSubList);
          }
        });
      });
    }

    closeDrawer() {
      this.classList.remove("is-open");
      document.body.classList.remove("menu-drawer-open");
      // Only remove if it was added
      if (this.hasBodyClickListener) {
        this.body.removeEventListener('click', this.boundBodyClick);
        this.hasBodyClickListener = false;
      }
    }

    onBodyClick(event) {
      // Only proceed if drawer is actually open
      if (this.classList.contains('is-open') && 
          !event.target.closest('.drawer-scrollable') && 
          !event.target.closest('.header-burger-menu')) {
        this.closeDrawer();
      }
    }

    toggleSubList(el) {
      if (el.classList.contains('is-open')) {
        // CLOSE
        el.classList.remove('is-open');

        el.style.transition = 'height 0.4s ease, opacity 0.4s ease';
        el.style.overflow = 'hidden';

        // Fix to current height then collapse
        el.style.height = el.scrollHeight + 'px';
        requestAnimationFrame(() => {
          el.style.height = '0px';
          el.style.opacity = 0;
        });

      } else {
        // OPEN
        el.classList.add('is-open');

        el.style.transition = 'height 0.4s ease, opacity 0.4s ease';
        el.style.overflow = 'hidden';
        el.style.opacity = 0;

        // Fix height to 0 before expanding
        el.style.height = '0px';
        requestAnimationFrame(() => {
          el.style.height = el.scrollHeight + 'px';
          el.style.opacity = 1;
        });

        // Clean up height to auto when done
        el.addEventListener('transitionend', function clearHeight(e) {
          if (e.propertyName === 'height') {
            if (el.classList.contains('is-open')) {
              el.style.height = 'auto';
            }
            el.removeEventListener('transitionend', clearHeight);
          }
        });
      }
    }
  }

  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}